// Temporary picker — all cats cut from the keeper's sheet.
const ROSTER = [
  { key: "A", id: 33, name: "sitting" },
  { key: "B", id: 39, name: "standing alert" },
  { key: "C", id: 44, name: "pouncing" },
  { key: "D", id: 7, name: "rolling play" },
  { key: "E", id: 46, name: "dancing" },
];

const BENCH = [
  { key: "1", id: 14, name: "belly up, tail high" },
  { key: "2", id: 10, name: "stretching long" },
  { key: "3", id: 49, name: "sprawled flat" },
  { key: "4", id: 40, name: "loaf, watching" },
  { key: "5", id: 28, name: "mid-leap" },
  { key: "6", id: 25, name: "on side, batting" },
  { key: "7", id: 34, name: "small spiky fluff" },
  { key: "8", id: 17, name: "crouched, glaring" },
];

const Tile = ({ cat, tone }) => (
  <div className="border border-[#232530] bg-[#0d0e12] p-4 flex flex-col items-center gap-3" data-testid={`picker-${tone}-${cat.key}`}>
    <img src={`/cats/cat-${cat.id}.png`} alt={cat.name} className="h-28 w-auto object-contain" />
    <p className="font-mono text-xs tracking-[0.2em] uppercase text-[#ede8e1]">{tone} {cat.key}</p>
    <p className="text-sm font-light text-[#a8a29e]">{cat.name}</p>
  </div>
);

export default function CatPicker() {
  return (
    <div className="min-h-screen bg-[#070709] p-10" data-testid="cat-picker">
      <h1 className="font-serif text-3xl text-[#ede8e1] mb-2">The cat roster</h1>
      <p className="text-[#a8a29e] font-light mb-8">Tell me any swap — e.g. "swap D for 4".</p>
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#581313] mb-4">On duty now</p>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 mb-12">
        {ROSTER.map((c) => <Tile key={c.key} cat={c} tone="Duty" />)}
      </div>
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#581313] mb-4">Waiting on the bench</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {BENCH.map((c) => <Tile key={c.key} cat={c} tone="Bench" />)}
      </div>
    </div>
  );
}
